import React from 'react';
import * as Styles from './styles';

const   ClickableTablecell = ({ onClick, disabled, children, id }) => {
  return <Styles.ClickableTablecell id={id} disabled={disabled} onClick={onClick}>{children}</Styles.ClickableTablecell>;
};

export default ClickableTablecell;
